import { render, staticRenderFns } from "./Term-Condition-Detail.vue?vue&type=template&id=0222551a"
import script from "./Term-Condition-Detail.vue?vue&type=script&lang=js"
export * from "./Term-Condition-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports